/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_roadmap_created_success = /** @type {(inputs: { title: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`로드맵 "${i?.title}"이(가) 성공적으로 생성되었습니다!`)
};

const en_roadmap_created_success = /** @type {(inputs: { title: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Roadmap "${i?.title}" has been successfully created!`)
};

/** @type {(inputs: { title: NonNullable<unknown> }) => LocalizedString} */
const ja_roadmap_created_success = ko_roadmap_created_success;

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ title: NonNullable<unknown> }} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const roadmap_created_success = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.roadmap_created_success(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("roadmap_created_success", locale)
	if (locale === "ko") return ko_roadmap_created_success(inputs)
	if (locale === "en") return en_roadmap_created_success(inputs)
	return ja_roadmap_created_success(inputs)
};